import type { FC } from 'react';
import React from 'react';
import { useFormikContext } from "formik";
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';

interface SummaryProps {
    onBack: (event: any) => void | undefined;
}

const ButtonSummary: FC<SummaryProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return (<>
        <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.description)}:</h2>
        <div className="flex">
            <div className="w-1/3">
                <h4 className="p-1 text-xs text-gray-600">
                    {translate.byKey(TranslationKeys.type)}:
                </h4>
            </div>
            <div className="w-2/3 mt-1">
                <div className="text-sm text-black">
                    {values.type}
                </div>
            </div>
        </div>

        <div className="flex pb-3">
            <div className="w-1/3">
                <h4 className="p-1 text-xs text-gray-600">
                    {translate.byKey(TranslationKeys.buttonText)}:
                </h4>
            </div>
            <div className="w-2/3 mt-1">
                <div className="text-sm text-black">
                    {values.buttonText}
                </div>
            </div>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>

            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="submit">
                    {translate.byKey(TranslationKeys.confirm)}
                </button>
            </div>
        </div>
    </>);
}

export default ButtonSummary;
